<template>
    <div class="total-box container">
        <div class="total">
            <h3>+1.3 milhão</h3>
            <h4>Negociações efetuadas</h4>
        </div>
        <div class="total">
            <h3>+4 mil</h3>
            <h4>Empresas cadastradas</h4>
        </div>
        <div class="total">
            <h3>+3.6 milhões</h3>
            <h4>CPF's cadastrados</h4>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LandPageTotals"
    }
</script>

<style scoped lang="scss">
    .total-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 120px;
        @media only screen and (max-width: 700px) {
            display: none;
        }
        @media only screen and (max-height: 430px) {
            display: none;
        }
    }

    .total{
        text-align: center;
        color: var(--whiteColor);
    }

    .total h3{
        color: var(--whiteColor);
        font-size: 38px;
        font-family: 'Montserrat-Bold';
    }

    .total h4{
        font-size: 16px;
        font-family: Cabin;
        color: var(--lightGrayColor)
    }
</style>
